// components
import Image from 'next/image';
import VisibleLoading from '@/components/utilities/VisibleLoading';

// utilities
import { getImagePath } from '@/utils/images';

const SquaresBlock = ({ platforms }) => {
  if (!platforms || !Array.isArray(platforms)) {
    return null;
  }

  const rows = [platforms.slice(0, 2), platforms.slice(2, 6), platforms.slice(6, 8)];

  return (
    <div className="flex min-w-[200px] flex-col items-center gap-2 py-8 xl:min-w-[630px] xl:gap-4 xl:py-2">
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className="flex flex-wrap justify-center gap-2 xl:gap-4">
          {row.map((item, itemIndex) => (
            <VisibleLoading key={`${rowIndex}-${itemIndex}`} delay={(rowIndex + itemIndex) * 100}>
              {({ ref, className }) => {
                const content = (
                  <div
                    ref={ref}
                    key={itemIndex}
                    className={`flex h-19 w-19 items-center justify-center rounded-xl border border-[0.75] border-white/20 bg-gray-200 bg-white/4 backdrop-blur-sm group-hover:border-white/40 group-hover:bg-white/8 xl:h-36 xl:w-36 ${className || ''}`}
                  >
                    {item.imageColor ? (
                      <Image
                        className="max-h-[55px] max-w-[70%] object-contain"
                        src={getImagePath(item.imageColor)}
                        width={item.imageColor.width}
                        height={item.imageColor.height}
                        alt={item.name}
                      />
                    ) : (
                      <Image
                        className="max-h-[55px] max-w-[70%] object-contain"
                        src={getImagePath(item.image)}
                        width={item.image.width}
                        height={item.image.height}
                        alt={item.name}
                      />
                    )}
                  </div>
                );

                return item.link ? (
                  <a href={item.link} target="_blank" className="group" rel="noopener noreferrer">
                    {content}
                  </a>
                ) : (
                  content
                );
              }}
            </VisibleLoading>
          ))}
        </div>
      ))}
    </div>
  );
};
export default SquaresBlock;
